export default __webpack_public_path__ + "static/media/close_btn_gray.4caa68ef.svg";